var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7474,
    cy: 14.7474,
    r: 14.7474,
    fill: "#F0EAFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36885 21.8832C7.89789 21.8832 7.49457 21.72 7.1589 21.3937C6.82323 21.0674 6.65568 20.6755 6.65625 20.2182V10.228C6.65625 9.77013 6.82409 9.37802 7.15976 9.05168C7.49543 8.72533 7.89846 8.56243 8.36885 8.56299H22.0697C22.5406 8.56299 22.9439 8.72616 23.2796 9.05251C23.6153 9.37885 23.7828 9.77069 23.7823 10.228V20.2182C23.7823 20.6761 23.6144 21.0682 23.2787 21.3945C22.9431 21.7209 22.54 21.8838 22.0697 21.8832H8.36885ZM8.36885 15.2231H22.0697V11.893H8.36885V15.2231Z",
    fill: "#008BD9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.15dad9ab1255045d924344c2b1896de2.svg";
export { ForwardRef as ReactComponent };